import { configureStore } from '@reduxjs/toolkit'
import farmsReducer from './farms'
import vaultsReducer from './vaults'
import poolsReducer from './pools'

export default configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    farms: farmsReducer,
    vaults: vaultsReducer,
    pools: poolsReducer,
  },
})
